module.exports = __webpack_public_path__ + "42917820e20a229ecc64c2c80879e9e9.jpg";